import { render, staticRenderFns } from "./historial-compras.vue?vue&type=template&id=5133f078&lang=html"
import script from "./historial-compras.vue?vue&type=script&lang=js"
export * from "./historial-compras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports